import { createSelectors } from "@/redux/helpers/selector";

import { MODULE } from "./constants";

export const [getInteractions, getIsLoaded] = createSelectors(MODULE, ["interactions", "isLoaded"]);

// What the signed-in user last chose for the given element, or undefined when
// they never touched it.
export const getInteraction = (state, key) => getInteractions(state)?.[key];
